export enum QRCodeItemPanels {
  NONE = 'none',
  COLOR_FILL = 'color-fill',
  BACKGROUND = 'background',
  ANIMATION = 'animation',
}
